export default "__VITE_ASSET__I4$oZZ4G__"